import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { MdHelp } from "react-icons/md";

////////Icono INFORMACION////////////////
const Informacion = "/informacion.svg";
////////Estilos/////////
const useStyles = makeStyles((theme) => ({
  icono: {
    marginTop: "-0.41em",
    width: "5%",
    position: "absolute",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 999,
  },
  root: {
    width: "99%",
    position: "absolute",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));

export default function HelpTitulo(props) {
  const classes = useStyles();
  //Popover
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (event) => {
    setAnchorEl(null);
  };
  const open2 = Boolean(anchorEl);
  /////fin popover///////

  return (
    <div className={classes.root}>
      <MdHelp
        aria-owns={open2 ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        className={classes.icono}
        style={{ width: "25px", height: "25px" }}
      />
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper2,
        }}
        open={open2}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography style={{ padding: "8px" }}>{props.descripcion}</Typography>
      </Popover>
    </div>
  );
}
